import styled from '@emotion/styled';
import { WarningAmber } from '@mui/icons-material';
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';
import {
  Box,
  Button,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Modal,
  Stack,
  Tooltip,
  tooltipClasses,
  TooltipProps,
  Typography,
} from '@mui/material';
import moment from 'moment';
import React, { useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  checkTherapyPlanning,
  deleteMdsAssessmentByDate,
  getSingleMdsAssessmentAction,
  resetCheckTherapyPlanning,
  resetGetSingleMdsAssessment,
  updateTherapyPlanningDischargeDate,
  updateUncoveredDayTherapyPlanning_2_0Action,
} from 'src/redux/actions/therapyPlanning';
import {
  CloseUncoveredIcon,
  DischargeIcon,
  MergeMdsAssessment,
  MergeMdsAssessmentColor,
  SquareCloseIcon,
  UncoveredDayIcon,
} from './commonComponent/therapy-planning-icons';
import { useTherapyPlanning } from './therapyPlanningProvider';
import { useNavigate } from 'react-router';
import { paths } from 'src/paths';
import { BootstrapDialog } from '../common-modals/BootstrapDialog';
import DeletePopupModal from 'src/components/common-modals/delete-modal';
const { therapyPlanning } = paths;

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '55%',
  borderRadius: '8px',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

interface UncoveredDayProps {
  selectedPatient: any;
  day: any;
  index: number;
  uncoveredCount: any;
  uncoveredDayResponse: any;
  uncoveredDay: any;
  mdsAssessments: any;
  setNavigateDate: any
}

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: 'white',
    color: 'black',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: ' rgba(0, 0, 0, 0.24) 0px 3px 8px',
    fontSize: 12,
  },
}));

function getCurrentDateUTCWithoutTime(date: any) {
  if (!date) return null;
  // Get the date components
  // const utcDateFormate = moment(date).format('YYYY-MM-DD');
  // Construct the UTC date string with time portion set to 00:00:00.000Z
  const utcDateString = `${date}T00:00:00.000Z`;

  return utcDateString;
}

const convertToUTC = (selectedDate: any) => {
  const selectedDateObj = new Date(selectedDate);
  const selectedYear = selectedDateObj.getFullYear();
  const selectedMonth = selectedDateObj.getMonth();
  const selectedDay = selectedDateObj.getDate();

  const systemDateObj = new Date();
  const systemHours = systemDateObj.getHours();
  const systemMinutes = systemDateObj.getMinutes();
  const systemSeconds = systemDateObj.getSeconds();

  // Create combined Date object
  const combinedDate = new Date(
    selectedYear,
    selectedMonth,
    selectedDay,
    systemHours,
    systemMinutes,
    systemSeconds
  );
  return combinedDate?.toISOString();
};

const UncoveredDay: React.FC<UncoveredDayProps> = ({
  selectedPatient,
  day,
  index,
  uncoveredDayResponse,
  uncoveredCount,
  uncoveredDay,
  mdsAssessments,
  setNavigateDate
}) => {
  const [isMdsCalenderHover, setIsMdsCalenderHover] = useState(false);
  const [selectedDischargeDate, setSelectedDischargeDate] = useState<any>(null);
  const getSingleMds = useSelector((state: any) => state.getSingleMdsAssessmentReducer)
  const dateOfServiceResponse = useSelector(
    (state: any) => state?.getDateOfServiceReducer?.response?.data
  );

  const { weekStartDate } = useTherapyPlanning();

  const [isOpen, setIsOpen] = useState(false);
  const calenderRef = useRef<HTMLDivElement | null>(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientInfo = useSelector((state: any) => state?.selectPatientReducer?.patientInfo);

  const getDischargeDatesOfTherapyPlanning2_0 = useSelector(
    (state: any) => state.getTherapyPlanningDischargeDateReducer_2_0?.response?.data
  );
  const isFuturePlanMinutes = useSelector((state: any) => state?.checkTherapyPlanningReducer);
  const providerId = useSelector(
    (state: any) => state?.getTherapistProfileReducer?.response?.data?.providerId
  );
  const [therapyType, setTherapyType] = useState('');
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const [deleteMdsAssessment, setDeleteMdsAssessment] = useState(false)
  const handleDeleteMds = () => {
    dispatch(deleteMdsAssessmentByDate({
      patientId: selectedPatient?.uuid,
      param: {
        date: day?.dateFormat
      },
      startDate: weekStartDate.format('YYYY-MM-DD'),
      endDate: weekStartDate.clone().add(8, 'days').format('YYYY-MM-DD'),
    }))
    setDeleteMdsAssessment(false)
  }


  const open = Boolean(anchorEl);
  const uncoveredDayResponseSort = uncoveredDayResponse?.sort((a: any, b: any) => {
    const date1: any = new Date(a?.date);
    const date2: any = new Date(b?.date);
    return date1 - date2;
  });
  let currentUncoveredDayCount = 0;
  uncoveredDay?.length === 9 &&
    !uncoveredDay[index]?.isUncoveredDay &&
    uncoveredDayResponseSort?.map(
      (list: any, currentIndex: number) =>
        index > currentIndex && list?.uncovered && currentUncoveredDayCount++
    );
  const eocStartDateWithoutTimeZone = selectedPatient?.eocStartDate?.split('T')?.at(0);
  const mdsCalendarDay = eocStartDateWithoutTimeZone
    ? moment(day?.dateFormat || new Date()).diff(
        moment(
          new Date(
            new Date(eocStartDateWithoutTimeZone).valueOf() +
              new Date(eocStartDateWithoutTimeZone).getTimezoneOffset() * 60 * 1000
          )?.toDateString()
        ),
        'days'
      ) >= 0
      ? moment(day?.dateFormat || new Date()).diff(
          moment(
            new Date(
              new Date(eocStartDateWithoutTimeZone).valueOf() +
                new Date(eocStartDateWithoutTimeZone).getTimezoneOffset() * 60 * 1000
            )?.toDateString()
          ),
          'days'
        ) +
        1 -
        uncoveredCount -
        currentUncoveredDayCount
      : 0
    : 0;

  const handleClick = (event: any) => {
    if (mdsCalendarDay <= 0) return;
    if (!anchorEl) {
      setSelectedDischargeDate(null);
      setAnchorEl(event.currentTarget);
    } else setAnchorEl(null);
  };

  const handleClose = () => {
    setIsMdsCalenderHover(false);
    setAnchorEl(null);
  };

  useMemo(() => {
    if (!isFuturePlanMinutes?.isFuturePlan && isFuturePlanMinutes?.response?.data === null) return;
    if (!isFuturePlanMinutes?.isFuturePlan && isFuturePlanMinutes?.response?.data !== null) return;

    if (
      isFuturePlanMinutes?.isFuturePlan &&
      isFuturePlanMinutes?.response?.data &&
      selectedDischargeDate
    ) {
      setIsOpen(true);
      dispatch(resetCheckTherapyPlanning());
      return;
    }
    if (
      isFuturePlanMinutes?.isFuturePlan &&
      !isFuturePlanMinutes?.response?.data &&
      selectedDischargeDate
    ) {
      dispatch(
        updateTherapyPlanningDischargeDate({
          ptDischargeDate:
            therapyType === 'PT'
              ? getCurrentDateUTCWithoutTime(selectedDischargeDate)
              : getCurrentDateUTCWithoutTime(
                getDischargeDatesOfTherapyPlanning2_0?.anticipatedPtDischargeDate
              ),
          otDischargeDate:
            therapyType === 'OT'
              ? getCurrentDateUTCWithoutTime(selectedDischargeDate)
              : getCurrentDateUTCWithoutTime(
                getDischargeDatesOfTherapyPlanning2_0?.anticipatedOtDischargeDate
              ),
          slpDischargeDate:
            therapyType === 'SLP'
              ? getCurrentDateUTCWithoutTime(selectedDischargeDate)
              : getCurrentDateUTCWithoutTime(
                getDischargeDatesOfTherapyPlanning2_0?.anticipatedSlpDischargeDate
              ),
          patientId: selectedPatient?.uuid,
          providerId: providerId,
          discipline: therapyType,
        })
      );

      setSelectedDischargeDate(null);
      dispatch(resetCheckTherapyPlanning());
      return;
    }
  }, [isFuturePlanMinutes, selectedDischargeDate]);

  const handleUncoveredDay = () => {
    if (!!mdsAssessments?.length && !(uncoveredDay?.length === 9 && uncoveredDay[index]?.isUncoveredDay)) {
      setDeleteMdsAssessment(true)
      return
    }
    dispatch(
      updateUncoveredDayTherapyPlanning_2_0Action({
        patientId: selectedPatient?.uuid,
        params: {
          date: day?.dateFormat,
          uncover: !(uncoveredDay?.length === 9 && uncoveredDay[index]?.isUncoveredDay),
        },
        startDate: weekStartDate.format('YYYY-MM-DD'),
        endDate: weekStartDate.clone().add(8, 'days').format('YYYY-MM-DD'),
      })
    );
    handleClose();
  };

  const handleSetDischarge = (discipline: 'OT' | 'PT' | 'SLP') => {
    setSelectedDischargeDate(day?.dateFormat);
    setTherapyType(discipline);
    dispatch(
      checkTherapyPlanning({
        dischargeDate: day?.dateFormat,
        type: discipline,
        patientId: selectedPatient?.uuid,
      })
    );
    setAnchorEl(null);
  };

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Box
        sx={{
          width: `calc(100% / 7)`,
          fontSize: '12px',
          borderRight: '1px solid #F2F4F7',

          height: '100%',
          cursor: 'pointer',
          padding: '3px',
          backgroundColor:
            (uncoveredDay?.length === 9 && uncoveredDay[index]?.isUncoveredDay)
              || !!mdsAssessments?.length ? '#F2F4F7' : 'white',
          color: '#6C737F',
          fontWeight: '500',
          display: 'flex',
          alignItems: 'center',
          marginBottom: '2px',
          justifyContent: 'center',
          position: 'relative',
        }}
      >
        <Stack
          onMouseEnter={() => setIsMdsCalenderHover(true)}
          onMouseLeave={() => {
            setAnchorEl(null);
            setIsMdsCalenderHover(false);
          }}
          ref={calenderRef}
          alignItems="center"
          justifyContent={'center'}
          sx={{
            width: '100%',
            position: 'relative',
            borderRadius: '8px',
            // backgroundColor: 'red',
            background: !!mdsAssessments?.length
              ? '#F0FDF9'
              : uncoveredDay?.length === 9 && uncoveredDay[index]?.isUncoveredDay
                ? '#FEE4E2'
                : isMdsCalenderHover && mdsCalendarDay > 0
                  ? '#2c394a0a'
                  : 'white',
            trasition: 'background 2s linear',
            height: '96%',
          }}
          flexDirection="row"
        >
          <Box />
          {uncoveredDay?.length === 9 && uncoveredDay[index]?.isUncoveredDay ? (
            <LightTooltip
              placement="top"
              title="Uncovered day"
            >
              <IconButton sx={{ width: '32px', height: '32px' }}>
                <UncoveredDayIcon />
              </IconButton>
            </LightTooltip>
          ) : (
            <Typography
              sx={{ display: 'block', textAlign: 'center' }}
              variant="caption"
            >
              {!!mdsAssessments?.length ? (
                  <Tooltip
                    placement="top"
                  title={
                    <span>
                      {mdsAssessments?.map((mds: any, index: number) => (
                        <div key={index}>{mds?.assessment_type}</div>
                      ))}
                    </span>
                  }
                  >
                    <IconButton>
                  <MergeMdsAssessmentColor />
                    </IconButton>
                  </Tooltip>
              ) : isNaN(mdsCalendarDay) ? (
                '-'
              ) : mdsCalendarDay ? (
                mdsCalendarDay
              ) : (
                '-'
              )}
            </Typography>
          )}
          {isMdsCalenderHover && mdsCalendarDay > 0 && (
            <MoreVertOutlinedIcon
              fontSize="small"
              sx={{ fontSize: '14px', position: 'absolute', right: '5px' }}
              onClick={handleClick}
              id="demo-positioned-button"
              aria-haspopup="true"
            />
          )}

          <Menu
            id="basic-menu"
            aria-labelledby="demo-positioned-button"
            anchorEl={anchorEl}
            // sx={{ display: openCalendar ? 'none' : 'initial' }}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            <MenuItem
              sx={{ gap: '12px', cursor: 'pointer', paddingRight: '32px' }}
              onClick={() => handleUncoveredDay()}
              // disabled={!!mdsAssessments?.length}
            >
              {uncoveredDay?.length === 9 && uncoveredDay[index]?.isUncoveredDay ? (
                <CloseUncoveredIcon />
              ) : (
                <UncoveredDayIcon />
              )}

              <Typography
                sx={{ fontSize: '12px', color: '#B42318', fontWeight: '500', lineHeight: '20px' }}
              >
                {uncoveredDay?.length === 9 && uncoveredDay[index]?.isUncoveredDay
                  ? `Cancel 'Uncovered Day'`
                  : `Mark as 'Uncovered Day'`}{' '}
              </Typography>
            </MenuItem>
            <MenuItem
              sx={{ gap: '12px', cursor: 'pointer' }}
              disabled={dateOfServiceResponse?.isOtEvalOnly}
              onClick={() => {
                if (getDischargeDatesOfTherapyPlanning2_0?.anticipatedOtDischargeDate) {
                  dispatch(
                    updateTherapyPlanningDischargeDate({
                      otDischargeDate: null,
                      patientId: selectedPatient?.uuid,
                      providerId: providerId,
                      discipline: 'OT',
                    })
                  );
                  setAnchorEl(null);
                } else {
                  handleSetDischarge('OT');
                }
              }}
            >
              {!getDischargeDatesOfTherapyPlanning2_0?.anticipatedOtDischargeDate ? (
                <DischargeIcon />
              ) : (
                <SquareCloseIcon />
              )}

              <Typography
                sx={{ fontSize: '12px', color: '#111927', fontWeight: '500', lineHeight: '20px' }}
              >
                {!getDischargeDatesOfTherapyPlanning2_0?.anticipatedOtDischargeDate
                  ? `Set Anticipated Discharge OT`
                  : `Remove Anticipated Discharge OT`}
              </Typography>
            </MenuItem>
            <MenuItem
              sx={{ gap: '12px', cursor: 'pointer' }}
              disabled={dateOfServiceResponse?.isPtEvalOnly}
              onClick={() => {
                if (getDischargeDatesOfTherapyPlanning2_0?.anticipatedPtDischargeDate) {
                  dispatch(
                    updateTherapyPlanningDischargeDate({
                      ptDischargeDate: null,
                      patientId: selectedPatient?.uuid,
                      providerId: providerId,
                      discipline: 'PT',
                    })
                  );
                  setAnchorEl(null);
                } else {
                  handleSetDischarge('PT');
                }
              }}
            >
              {!getDischargeDatesOfTherapyPlanning2_0?.anticipatedPtDischargeDate ? (
                <DischargeIcon />
              ) : (
                <SquareCloseIcon />
              )}
              <Typography
                sx={{ fontSize: '12px', color: '#111927', fontWeight: '500', lineHeight: '20px' }}
              >
                {!getDischargeDatesOfTherapyPlanning2_0?.anticipatedPtDischargeDate
                  ? `Set Anticipated Discharge PT`
                  : `Remove Anticipated Discharge PT`}
              </Typography>
            </MenuItem>
            <MenuItem
              sx={{ gap: '12px', cursor: 'pointer' }}
              disabled={dateOfServiceResponse?.isSlpEvalOnly}
              onClick={() => {
                if (getDischargeDatesOfTherapyPlanning2_0?.anticipatedSlpDischargeDate) {
                  dispatch(
                    updateTherapyPlanningDischargeDate({
                      slpDischargeDate: null,
                      patientId: selectedPatient?.uuid,
                      providerId: providerId,
                      discipline: 'SLP',
                    })
                  );
                  setAnchorEl(null);
                } else {
                  handleSetDischarge('SLP');
                }
              }}
            >
              {!getDischargeDatesOfTherapyPlanning2_0?.anticipatedSlpDischargeDate ? (
                <DischargeIcon />
              ) : (
                <SquareCloseIcon />
              )}

              <Typography
                sx={{ fontSize: '12px', color: '#111927', fontWeight: '500', lineHeight: '20px' }}
              >
                {!getDischargeDatesOfTherapyPlanning2_0?.anticipatedSlpDischargeDate
                  ? `Set Anticipated Discharge SLP`
                  : `Remove Anticipated Discharge SLP`}
              </Typography>
            </MenuItem>
            <MenuItem
              sx={{ gap: '12px', cursor: 'pointer' }}
              disabled={uncoveredDay?.length === 9 && uncoveredDay[index]?.isUncoveredDay || getSingleMds?.loading}
              onClick={() => {

                if (mdsAssessments?.length === 1) {
                  dispatch(resetGetSingleMdsAssessment())
                  setNavigateDate(day?.dateFormat)
                  dispatch(getSingleMdsAssessmentAction({
                    mdsAssessmentId: mdsAssessments?.[0]?.uuid
                  }))
                  return
                }
                if (!!mdsAssessments?.length) {
                  navigate(`${therapyPlanning.index}${therapyPlanning.details}`, {
                    state: {
                      patientId: patientInfo?.uuid,
                      ARD_Date: day?.dateFormat,
                      from: 'ARD_Tab',
                    },
                  })
                  return
                }
                navigate(
                  `${therapyPlanning.index}${therapyPlanning.details}${therapyPlanning.editDetails}`,
                  {
                    state: {
                      action:'Create',
                      selectedPatient: patientInfo,
                      from: 'ARD_Tab',
                      ARD_Date: day?.dateFormat,
                    },
                  }
                );
              }}
            >
              <MergeMdsAssessment />
              <Typography
                sx={{ fontSize: '12px', color: '#111927', fontWeight: '500', lineHeight: '20px' }}
              >
                {
                  !!mdsAssessments?.length ? 'Edit ARD' : 'Set ARD'
                }
              </Typography>
            </MenuItem>
          </Menu>
        </Stack>
      </Box>
      <Modal
        open={isOpen}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          ref={calenderRef}
          sx={style}
        >
          <Stack
            flexDirection="row"
            gap="1rem"
            alignItems={'center'}
          >
            {
              <Grid
                container
                alignItems="center"
                justifyContent={'center'}
                sx={{
                  marginBottom: '1rem',
                  width: '65px',
                  minWidth: '55px',
                  height: '50px',
                  borderRadius: '50%',
                  background: 'rgba(247, 144, 9, 0.12)',
                  color: '#B54708',
                }}
              >
                <WarningAmber sx={{ height: '30px', width: '30px' }} />
              </Grid>
            }
            <Stack gap=".75rem">
              <Typography
                id="modal-modal-title"
                variant="h5"
              >
                {'Remove future planned minutes?'}
              </Typography>
              <Typography
                id="modal-modal-title"
                variant="caption2Text"
              >
                {
                  'Selecting an anticipated discharge date will remove any planned minutes and scheduled sessions after this date. Are you sure you want to select this date?'
                }
              </Typography>
            </Stack>
          </Stack>
          <Stack
            flexDirection="row"
            gap="1rem"
            justifyContent="flex-end"
            sx={{ marginTop: '1rem' }}
          >
            <Button
              onClick={() => {
                dispatch(resetCheckTherapyPlanning());
                setSelectedDischargeDate(null);
                setIsOpen(false);
                handleCloseModal();
              }}
              color="inherit"
            >
              {'Cancel'}
            </Button>
            <Button
              variant="contained"
              color={'primary'}
              onClick={() => {
                dispatch(
                  updateTherapyPlanningDischargeDate({
                    ptDischargeDate:
                      therapyType === 'PT'
                        ? getCurrentDateUTCWithoutTime(selectedDischargeDate)
                        : getCurrentDateUTCWithoutTime(
                          getDischargeDatesOfTherapyPlanning2_0?.anticipatedPtDischargeDate
                        ),
                    otDischargeDate:
                      therapyType === 'OT'
                        ? getCurrentDateUTCWithoutTime(selectedDischargeDate)
                        : getCurrentDateUTCWithoutTime(
                          getDischargeDatesOfTherapyPlanning2_0?.anticipatedOtDischargeDate
                        ),
                    slpDischargeDate:
                      therapyType === 'SLP'
                        ? getCurrentDateUTCWithoutTime(selectedDischargeDate)
                        : getCurrentDateUTCWithoutTime(
                          getDischargeDatesOfTherapyPlanning2_0?.anticipatedSlpDischargeDate
                        ),
                    patientId: selectedPatient?.uuid,
                    providerId: providerId,
                    discipline: therapyType,
                  })
                );
                dispatch(resetCheckTherapyPlanning());
                setSelectedDischargeDate(null);
                setIsOpen(false);
                handleCloseModal();
              }}
            >
              {'Confirm'}
            </Button>
          </Stack>
        </Box>
      </Modal>
      <BootstrapDialog
        onClose={() => setDeleteMdsAssessment(false)}
        aria-labelledby="customized-dialog-title"
        open={deleteMdsAssessment}
      >
        <DeletePopupModal
          close={() => setDeleteMdsAssessment(false)}
          message={'Setting an Uncovered Day will delete the Assessment. This action cannot be undone.'}
          button={{ saveLabel: 'Delete', closeLabel: 'Cancel' }}
          title={'Delete MDS Assessment?'}
          handleSaveBtn={handleDeleteMds}
        />
      </BootstrapDialog>
    </>
  );
};

export default UncoveredDay;
